import React, { useState, useMemo, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import {
  MobileStateQuestion,
  SaveDataAnswerGroup,
} from '@safeguardproperties/corescript-react-npm/dist/types';
import {
  NumericFormat,
  PatternFormat,
  NumberFormatValues,
} from 'react-number-format';
import useValidation from '../hooks/useNumericFieldValidation';

interface CustomFormatProps {
  question: MobileStateQuestion;
  stringMapper: (key: string) => string;
  answers: SaveDataAnswerGroup | undefined;
  onSetAnswer: (questionKey: string, answers: string[]) => void;
  format: string;
  prefix?: string;
  suffix?: string;
  validationRules?: {
    regex: RegExp;
    errorMessage: string;
  }[];
  // other TextField props can be included here as needed
  [key: string]: any;
}

const CustomFormat: React.FC<CustomFormatProps> = ({
  question,
  stringMapper,
  answers,
  onSetAnswer,
  format,
  prefix,
  suffix,
  validationRules,
  ...props
}) => {
  const label = useMemo(() => {
    if (stringMapper) {
      return stringMapper(question?.Title);
    }
    return question?.Title;
  }, [question, stringMapper]);

  const [formattedValue, setFormattedValue] = useState<string>('');
  const [value, setValue] = useState<string>('0');
  const [numbericValue, setnumbericValue] = useState<number | undefined>(0);

  const error = useValidation(formattedValue, validationRules || []);

  useEffect(() => {
    if (answers !== undefined && answers?.Answers !== undefined) {
      setValue(answers?.Answers[0]?.Answer ?? '');
    }
  }, [answers]);

  const validateInput = () => {
    if (value) {
      onSetAnswer(question.QuestionKey, [value]);
    } else {
      onSetAnswer(question.QuestionKey, ['']);
    }
  };
  const commonProps = {
    value,
    customInput: TextField,
    InputProps: {
      startAdornment: prefix ? (
        <InputAdornment position='start'>{prefix}</InputAdornment>
      ) : null,
      endAdornment: suffix ? (
        <InputAdornment position='end'>{suffix}</InputAdornment>
      ) : null,
    },
    onValueChange: (values: NumberFormatValues) => {
      setnumbericValue(values.floatValue);
      setValue(values.value);
      setFormattedValue(values.formattedValue);
    },
    label,
    error: !!error,
    helperText: error,
    ...props,
  };

  return (
    <PatternFormat
      {...commonProps}
      format={format}
      mask='_'
      onBlur={validateInput}
    />
  );
};

export default CustomFormat;
